import React, { useState, useEffect } from "react";
import { Fab, Fade, Grow, Slide } from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import LogWindow from "./LogWindow";
import { HubMessageNotification } from "Infrastructure/Models/Messages/MessageNotification";

export interface LogEntry {
	message: string;
	timestamp: string;
	notification?: HubMessageNotification | null;
}

const LogController: React.FC = () => {
	const [logs, setLogs] = useState<LogEntry[]>([]);
	const [showLogWindow, setShowLogWindow] = useState(false);

	useEffect(() => {
		const storedLogs: LogEntry[] = JSON.parse(
			localStorage.getItem("serverLogs") || "[]"
		);
		setLogs(storedLogs);
	}, []);

	const addLog = (
		message: string,
		notification?: HubMessageNotification | null
	) => {
		const timestamp = new Date().toLocaleTimeString([], {
			hour: "2-digit",
			minute: "2-digit",
			second: "2-digit",
			hour12: false,
		});
		console.log(
			`[${timestamp}] ${
				notification
					? `[${notification.requestId}] ${
							notification.isReceivedMessage ? "Receive" : "Publish"
					  } ${notification.requestMessageType}`
					: ""
			}`,
			{
				timestamp,
				message,
				notification,
			}
		);
		const updatedLogs = [...logs, { timestamp, message, notification }];
		if (updatedLogs.length > 1000) {
			updatedLogs.shift();
		}
		setLogs(updatedLogs);
		localStorage.setItem("serverLogs", JSON.stringify(updatedLogs));
	};

	useEffect(() => {
		const handleAddLog = (event: Event) => {
			const customEvent = event as CustomEvent<{
				message: string;
				notification?: HubMessageNotification | null;
			}>;

			addLog(customEvent.detail.message, customEvent.detail.notification);
		};

		document.addEventListener("addLog", handleAddLog as EventListener);

		return () => {
			document.removeEventListener("addLog", handleAddLog as EventListener);
		};
	}, [addLog]);

	const toggleLogWindow = () => {
		setShowLogWindow(!showLogWindow);
	};

	const handleClearLogs = () => {
		setLogs([]);
		localStorage.removeItem("serverLogs");
	};

	return (
		<>
			<Fab
				color="primary"
				aria-label="toggle-log"
				onClick={toggleLogWindow}
				sx={{
					position: "fixed",
					bottom: 16,
					right: 16,
					zIndex: 1000,
				}}
			>
				<MenuIcon />
			</Fab>

			{showLogWindow && <LogWindow logs={logs} onClearLogs={handleClearLogs} />}
		</>
	);
};

export default LogController;
